module.exports = __webpack_public_path__ + "static/media/user-pin-inactive.86cd9d4e.svg";